import { getApiBaseUrl } from "src/config/Endpoints";

const API_BASE_URL = getApiBaseUrl();

export const fetchShopifyAccountDetails = async (
  tenant_id: string,
  api_key: string
) => {
  const response = await fetch(
    `${API_BASE_URL}/shopify/fetch-existing-account-details?tenant_id=${tenant_id}&api_key=${api_key}`,
    {
      method: "POST",
      headers: {
        "Accept": "application/json",
        // ⚠️ No Content-Type, no Authorization header
        // because backend expects api_key in query params
      },
      body: "" // send empty string as body, same as curl -d ''
    }
  );

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    console.error("Fetch Shopify Account Details Error:", error);
    throw new Error(error?.detail || "Failed to fetch account details");
  }

  return response.json();
};

export const testShopifyConnection = async (
  api_key: string,
  data: any
): Promise<void> => {
  const response = await fetch(`${API_BASE_URL}/shopify/test-connection`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${api_key}`,
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error("Test connection failed.");
  }
};

export const createShopifyConnection = async (
  api_key: string,
  data: any
): Promise<any> => {
  const response = await fetch(`${API_BASE_URL}/shopify/create-connection`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${api_key}`,
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error("Failed to create connection.");
  }
  return response.json();
};

export const removeShopifyConnection = async (
  api_key: string,
  tenant_id: string
): Promise<any> => {
  const source_name = "shopify";
  const response = await fetch(
    `${API_BASE_URL}/remove-connection?tenant_id=${tenant_id}&source_name=${source_name}&api_key=${api_key}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${api_key}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to remove connection.");
  }
  return response.json();
};
